import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FBWhite, FbLogoPNG, LPLogoWName, Logo1024PNG, Selfie, Selfie2 } from "../../assets/index";
import SignupForm from "@Components/SignupForm";
import styles from "./styles";
import { RootState, useAppSelector } from "@Store/store";

const Signup2 = () => {


  const navigate = useNavigate();

  // const { user } = useAppSelector((state: RootState) => state.profile);

  // useEffect(() => {
  //   if (user?.user_id) {
  //     navigate("/dashboard/automations")
  //   }
  // }, [user])

  useEffect(() => {
    document.title = "LinkPlease - Signup";
  }, []);


  return (
    <div style={styles.SIGNUP_CONTAINER} className="min-h-screen w-full flex items-center justify-center"
    >
      <div className="max-w-[500px] flex flex-col items-center bg-white p-4 rounded-2xl" style={styles.SIGNUP_CONTAINER}>
        <div className="m-2">
          <img src={LPLogoWName} className="w-[150px]" alt="Linkplease Logo" />
        </div>

        <div className="text-center m-4">
          <h1 className="text-[1.2rem] ">Hey👋, Lets make you viral🚀 </h1>
          {/* <h1 className="text-[1.2rem] font-semibold">Start Your Journey! 🚀</h1> */}
        </div>

        <div className="w-full">
          <SignupForm />
        </div>
        <div className="mt-6 text-center">
          <p className="text-[#787781] text-sm">
            Already have an account?{" "}
            <span
              className="text-[#7772FF] hover:cursor-pointer hover:underline"
              onClick={() => navigate("/login")}
            >
              Login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup2;
